<template>
    <div>
        <div class="card-header">
            <div class="row justify-content-end">
                <div class="col-3">
                    <Button class="float-right" @click="showModal('crear-patrocinador')">AÑADIR PATROCINADOR</Button>
                    <CreatePatrocinador @close="closeModal"/>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div :class="['table', { 'expanded': patrocinadores.length <= 3 }]">
                <table :class="['table', { 'expanded': patrocinadores.length <= 3 }, 'table-hover text-nowrap']">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Imagen</th>
                            <th>Url</th>
                            <th>Mostrar en la entrada</th>
                            <th class="text-center">opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(patrocinador, index) in patrocinadores">
                            <tr :key="index">
                                <td>{{ patrocinador.nombre }}</td>
                                <td>
                                    <img :src="patrocinador.imagen_url" style="max-height: 100px"/>
                                </td>
                                <td>{{ patrocinador.url }}</td>
                                <td class="text-center">
                                    <span style="font-size: 20px" :class="patrocinador.show_in_ticket ? 'text-success' : 'text-danger'">
                                        <i :class="patrocinador.show_in_ticket ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                    </span>
                                </td>
                                <td class="text-center">
                                    <OpcionesDropdownTableComponent 
                                        :lastIndex="patrocinadores.length > 3 && index >= patrocinadores.length - 3"
                                        v-bind:options="[
                                            { type: 'action', action:() => showModal('borrar-patrocinador-' + patrocinador.id), label: 'Borrar'},
                                            { type: 'action', action:() => showModal('editar-patrocinador-' + patrocinador.id), label: 'Editar'}
                                        ]" 
                                        class="ml-2"
                                    />
                                </td>
                                <BorrarPatrocinador :patrocinador="patrocinador" @close="closeModal"/>
                                <EditarPatrocinador :patrocinador="patrocinador" @close="closeModal"/>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="7">
                                <LoaderComponent/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>    
</template>

<script>
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';
    import CreatePatrocinador from './modals/CreatePatrocinador';
    import BorrarPatrocinador from './modals/BorrarPatrocinador';
    import EditarPatrocinador from './modals/EditarPatrocinador';

    export default {
        props: [],
        data() {
            return {
                loading: false
            }
        },
        computed: {
            patrocinadores() {
                return this.$store.getters.getPatrocinadores;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar');
            },
            showModal(modal) {
                this.expand = [];
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getFooter();
                }
            },
            getFooter() {
                const params = {
                    filters : {
                        tid : this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('settings'), params).then(res => {
                    this.loading = false;
                });
            }
        },
        components: {
            OpcionesDropdownTableComponent, CreatePatrocinador, BorrarPatrocinador, EditarPatrocinador
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>